module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0741c_banner_800x600.5fc2402a.png";